module.exports = __webpack_public_path__ + "img/chips2000.d2858764.webp";